import { PDFDocument, StandardFonts } from "pdf-lib";

async function generateExamNumberReport(examNumbers) {
  const pdfDoc = await PDFDocument.create();
  const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman);

  const examNumbersPerPage = 45;
  const spacingBetweenExamNumbers = 15;
  const topExamNumberYValue = 730;
  const examNumberXValue = 45;
  const examNumberXOffset = 150;

  let LengthOfItems = examNumbers.length;

  let numPages = Math.ceil(LengthOfItems / examNumbersPerPage / 2);

  for (let i = 0; i < numPages; i++) {
    pdfDoc.addPage();
  }

  const pages = pdfDoc.getPages();

  const fontSize = 13;

  let currentPageIndex = 0;
  let x = examNumberXValue;
  let y = topExamNumberYValue;

  let currentPage = pages[currentPageIndex];
  let needSecondCol = 1;

  for (let i = 0; i < LengthOfItems; i++) {
    if (i % examNumbersPerPage === 0 && i !== 0) {
      if (i + examNumbersPerPage < LengthOfItems) {
        i = i + examNumbersPerPage;
      } else {
        break;
      }
    }

    currentPage.drawText("Exam Number Report", {
      x: 45,
      y: 780,
      size: fontSize,
      font: timesRomanFont,
    });

    currentPage.drawText("Page " + (currentPageIndex + 1) + " / " + numPages, {
      x: 465,
      y: 780,
      size: fontSize * 0.8,
    });

    currentPage.drawText(
      examNumbers[i].last_name + ", " + examNumbers[i].first_name || "",
      {
        x: x,
        y: y,
        size: fontSize,
      }
    );
    currentPage.drawText(
      examNumbers[i].exam_number?.toString().padStart(3, "0") || "",
      {
        x: x + examNumberXOffset,
        y: y,
        size: fontSize,
      }
    );

    let secondColIndex = i;
    if (secondColIndex + examNumbersPerPage < LengthOfItems) {
      secondColIndex = i + examNumbersPerPage;
    } else {
      if (LengthOfItems - i >= examNumbersPerPage) {
        secondColIndex = i + examNumbersPerPage;
      } else {
        needSecondCol = 0;
      }
    }

    if (needSecondCol) {
      currentPage.drawText(
        examNumbers[secondColIndex].last_name +
          ", " +
          examNumbers[secondColIndex].first_name || "",
        {
          x: x + 2 * examNumberXOffset,
          y: y,
          size: fontSize,
        }
      );
      currentPage.drawText(
        examNumbers[secondColIndex].exam_number?.toString().padStart(3, "0") ||
          "",
        {
          x: x + 3 * examNumberXOffset,
          y: y,
          size: fontSize,
        }
      );
    }

    if ((i + 1) % examNumbersPerPage === 0) {
      y = topExamNumberYValue;
      currentPageIndex++;
      currentPage = pages[currentPageIndex];
    } else {
      y -= spacingBetweenExamNumbers;
    }
  }

  let pdfBytes = await pdfDoc.save();

  const file = new Blob([pdfBytes], {
    type: "application/pdf",
  });
  file.name = "honors-letter.pdf";
  const fileURL = URL.createObjectURL(file);
  window.open(fileURL);
}

export default generateExamNumberReport;
